// extracted by mini-css-extract-plugin
export default {"statisticsPageHero":"StatisticsPageHero_statisticsPageHero__mJ9oY","content":"StatisticsPageHero_content__KVQvc"};